import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .container_authorize_wrapper {
    padding: 48px 0;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    justify-content: center;
    .component_authorize_title {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 12px;
    }
    .component_authorize_box {
      background-color: ${color.orange6};
      border-radius: 12px;
      text-align: center;
      max-width: 514px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 20px;
      padding: 12px 24px;
      text-align: left;
      .anticon {
        color: ${color.orange1};
        font-size: 24px;
      }
    }
    .component_authorize_permission {
      max-width: 656px;
      margin: 0 auto;
      text-align: center;
    }
    .component_authorize_image {
      max-width: 624px;
      margin: 0 auto;
    }
  }
`;

export default Wrapper;
